var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBubble = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.5.25a4.25 4.25 0 1 0 0 8.5 4.25 4.25 0 0 0 0-8.5zM3 6.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5zM9 11.25a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBubble);
export default ForwardRef;